import { useState } from "react";

export const faqs = [
  {
    question: "Peut-on électrifier n'importe quel volet roulant manuel ?",
    answer: "Dans la plupart des cas, oui. Nous pouvons électrifier la majorité des volets roulants manuels, qu'ils soient à sangle, à cordon ou à manivelle. Les conditions sont que le tablier soit en bon état et que le coffre dispose d'un espace suffisant pour accueillir le moteur tubulaire. Nos techniciens vérifient ces points lors de la visite technique. Si le volet est trop usé, déformé ou si le coffre est trop petit, nous vous proposons une alternative adaptée, comme une motorisation sur un volet neuf ou une réparation préalable.",
  },
  {
    question: "Faut-il refaire l'électricité pour électrifier un volet ?",
    answer: "Non, dans la plupart des cas. Si une prise de courant est disponible à proximité du coffre (environ 1,5 mètre), le raccordement se fait directement avec un filin dissimulé. Si aucune prise n'est accessible, nous étudions la faisabilité d'une petite extension électrique ou d'une solution sans fil. Nos techniciens vous expliquent les options lors du devis. L'électrification Somfy ne nécessite jamais de gros travaux de rénovation électrique.",
  },
  {
    question: "Quel est le délai pour une électrification Somfy ?",
    answer: "Nous intervenons sous 24 à 48 heures après votre demande dans Strasbourg et le Bas-Rhin. La visite technique dure environ 30 minutes : nous mesurons, vérifions la compatibilité et vous présentons un devis. L'installation proprement dite se fait en une à deux heures par volet. Vous disposez d'un volet électrique et fonctionnel le jour même. Pour plusieurs volets, nous planifions l'intervention en une seule journée.",
  },
  {
    question: "Quel est le coût d'une électrification de volet ?",
    answer: "Le coût d'une électrification dépend de plusieurs facteurs : le type de moteur choisi (filaire, RTS ou io), le nombre de volets à transformer, la présence ou non d'une prise électrique à proximité, et le type de commandes souhaitées. Le devis est gratuit et détaillé : il inclut le moteur, la main d'œuvre, le raccordement électrique et la mise en service. Nous vous proposons toujours la solution la plus adaptée à votre budget et à vos besoins. Contactez-nous au 03 74 47 32 40 pour un devis personnalisé.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold text-center mb-10 md:mb-14">
          Questions fréquentes sur l'électrification Somfy
        </h2>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-brand-border rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left hover:bg-brand-light/50 transition-colors"
              >
                <span className="text-brand-blue text-base font-semibold">{faq.question}</span>
                <span className="shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-brand-cyan/10">
                  <i className={`ri-${openIndex === index ? "subtract" : "add"}-line text-brand-cyan text-lg`}></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-5 md:px-6 md:pb-6">
                  <p className="text-brand-text text-sm md:text-base leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}